module.exports = __webpack_public_path__ + "img/sld_scb_7_t1_b1_dark.41a8657a.svg";